// Chakra imports
import {
    Table,
    Tbody,
    Tr,
    Td,
    TableContainer, Text, useColorModeValue, Box, Icon, Thead, Th,
} from '@chakra-ui/react'
import React, {useState} from "react";
import "./modal.css"
import {FaEye, FaEyeSlash} from "react-icons/fa";


const TransactionInfoJson = ({ title, value }) => {

    const textColor = useColorModeValue("gray.700", "white");
    const [selected, setSelected] = useState(true)

    const objectArray = Object.entries(value);

    const toggle = () => {
        setSelected(!selected)
    }

    return (
        <>
            <TableContainer>
                <Table bg={"#7fdfd6"} colorScheme='teal'>
                    <Thead>
                        <Tr>
                            <Th width={"100%"}>
                                <Text
                                    fontSize='md'
                                    color={textColor}
                                    cursor="pointer"
                                    onClick={toggle}
                                >
                                    {title}
                                </Text>
                            </Th>
                            <Th>
                                <Icon
                                    as={(selected) ? FaEye : FaEyeSlash}
                                    color="gray.400"
                                    cursor="pointer"
                                    onClick={toggle}
                                    style={{
                                        "width": "18px",
                                        "height": "18px"
                                    }}
                                />
                            </Th>
                        </Tr>
                    </Thead>
                </Table>
            </TableContainer>
            {selected &&
            <TableContainer>
                <Table variant='striped'>
                    <Tbody maxWidth={"100%"}>
                        {objectArray.map(([key, val], id) => {
                            return (
                                <Tr key={id} style={{"whiteSpace": "pre-wrap"}}>
                                    <Td width="300px" fontWeight='bold'>{key}</Td>
                                    <Td>{JSON.stringify(val, null, 2)}</Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
            }
        </>
    )

}

export default TransactionInfoJson;

